import { Extension } from "../../core/extension";
import { floatingToolbarPlugin, staticToolbarPlugin } from "./plugin";
import pickBy from "lodash/pickBy";
import { text } from "./text";
export const defaultOptions = {
    mode: "floating",
    showToolbarButtonDividers: true,
    showToolbarButtonArrows: true,
    disableTooltips: false,
    dashboardsStyle: false,
};
/**
 * Adds a formatting toolbar to the editor.
 */
export class FormattingToolbarExtension extends Extension {
    constructor(options = defaultOptions) {
        super();
        this.options = options;
    }
    addPlugins(schema, plugins, { commands, portalContainer }) {
        return plugins.concat([
            this.options.mode === "floating"
                ? floatingToolbarPlugin(portalContainer, commands, this.options.dashboardsStyle && items(commands), !this.options.dashboardsStyle)
                : staticToolbarPlugin(portalContainer, commands, this.options, this.options.dashboardsStyle && items(commands), !this.options.dashboardsStyle),
        ]);
    }
}
export const items = (commands) => {
    var _a, _b, _c, _d, _e;
    const allItems = {
        heading1: {
            title: text.heading1,
            command: (_a = commands.applyHeading) === null || _a === void 0 ? void 0 : _a.call(commands, 1),
            separator: false,
            lastHotkey: "1",
            type: "heading1-dashboards",
        },
        heading2: {
            title: text.heading2,
            command: (_b = commands.applyHeading) === null || _b === void 0 ? void 0 : _b.call(commands, 2),
            separator: false,
            lastHotkey: "2",
            type: "heading2-dashboards",
        },
        heading3: {
            title: text.heading3,
            command: (_c = commands.applyHeading) === null || _c === void 0 ? void 0 : _c.call(commands, 3),
            separator: false,
            lastHotkey: "3",
            type: "heading3-dashboards",
        },
        heading4: {
            title: text.heading4,
            command: (_d = commands.applyHeading) === null || _d === void 0 ? void 0 : _d.call(commands, 4),
            separator: true,
            lastHotkey: "4",
            type: "heading4-dashboards",
        },
        extraLarge: {
            title: text.extraLarge,
            command: commands.applyParagraphWithAttributes({ size: "extra-large" }),
            separator: false,
            lastHotkey: "5",
            type: "heading5-dashboards",
        },
        largeText: {
            title: text.largeText,
            command: commands.applyParagraphWithAttributes({ size: "large" }),
            separator: false,
            lastHotkey: "6",
            type: "heading6-dashboards",
        },
        paragraph: {
            title: text.mediumText,
            command: commands.applyParagraphWithAttributes({ size: "medium" }),
            separator: false,
            lastHotkey: "7",
            type: "normal-text-dashboards",
        },
        small: {
            title: text.smallText,
            command: commands.applyParagraphWithAttributes({ size: "small" }),
            separator: true,
            lastHotkey: "8",
            type: "small-text-dashboards",
        },
        caption: {
            title: text.caption,
            command: (_e = commands.applyHeading) === null || _e === void 0 ? void 0 : _e.call(commands, 6),
            separator: false,
            lastHotkey: "9",
            type: "caption",
        },
    };
    return pickBy(allItems, (item) => !!item.command); // filter out missing commands
};
